"use strict";
/* UNIT */
Object.defineProperty(exports, "__esModule", { value: true });
var Unit = {
    frac2hex: function (frac) {
        var hex = Math.round(frac * 255).toString(16);
        return hex.length > 1 ? hex : "0" + hex;
    },
    dec2hex: function (dec) {
        var hex = Math.round(dec).toString(16);
        return hex.length > 1 ? hex : "0" + hex;
    }
};
/* EXPORT */
exports.default = Unit;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/utils/unit.js
// module id = 2054
// module chunks = 0